import React from "react";
const CheckAuth = React.createContext();

export default CheckAuth;
